import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input"]

  connect() {
    this.sanitizar()
  }

  bloquearLetras(event) {
    const teclasPermitidas = [
      "Backspace", "Delete", "Tab", "Escape", "Enter",
      "ArrowLeft", "ArrowRight", "ArrowUp", "ArrowDown",
      "Home", "End"
    ]

    if (event.ctrlKey || event.metaKey) return
    if (teclasPermitidas.includes(event.key)) return
    if (/^[\d.]$/.test(event.key)) return

    event.preventDefault()
  }

  colarSomenteIp(event) {
    event.preventDefault()

    const texto = (event.clipboardData || window.clipboardData).getData("text")
    const valor = this.somenteCaracteresPermitidos(texto).slice(0, 15)

    this.inputTarget.value = valor
    this.limparErro()
  }

  sanitizar() {
    const valor = this.somenteCaracteresPermitidos(this.inputTarget.value).slice(0, 15)
    this.inputTarget.value = valor
    this.limparErro()
  }

  validar() {
    const valor = this.inputTarget.value.trim()

    if (valor.length === 0 || this.ipValido(valor)) {
      this.limparErro()
      return
    }

    this.marcarErro("Informe um endereço IP válido")
  }

  ipValido(valor) {
    const blocos = valor.split(".")

    return blocos.length === 4 && blocos.every(bloco => {
      if (!/^\d{1,3}$/.test(bloco)) return false
      if (bloco.length > 1 && bloco.startsWith("0")) return false

      const numero = Number(bloco)
      return numero >= 0 && numero <= 255
    })
  }

  somenteCaracteresPermitidos(valor) {
    return String(valor || "").replace(/[^\d.]/g, "")
  }

  marcarErro(mensagem) {
    this.inputTarget.setCustomValidity(mensagem)
    this.inputTarget.classList.add("is-invalid")
    this.feedbackElement().textContent = mensagem
  }

  limparErro() {
    this.inputTarget.setCustomValidity("")
    this.inputTarget.classList.remove("is-invalid")

    const feedback = this.feedbackElement(false)
    if (feedback) feedback.textContent = ""
  }

  feedbackElement(criar = true) {
    const next = this.inputTarget.nextElementSibling

    if (next && next.classList.contains("invalid-feedback")) return next
    if (!criar) return null

    const div = document.createElement("div")
    div.className = "invalid-feedback"
    this.inputTarget.insertAdjacentElement("afterend", div)
    return div
  }
}
